'use strict';
module.exports = require('./BadgeDirective.js');